import axios from "axios";
import { BASE_URL } from "./api";

// List the current user's MCP tokens (labels/dates only — never the secret).
export async function listMCPTokens(token) {
    return axios({
        method: "get",
        url: `${BASE_URL}/mcp-tokens/`,
        headers: { Authorization: `Token ${token}` },
    }).then((response) => response).catch((error) => {
        console.log(error);
        return error;
    });
}

// Mint a new MCP token. On success the raw secret is in response.data.token —
// shown to the user only once.
export async function mintMCPToken(token, label) {
    return axios({
        method: "post",
        url: `${BASE_URL}/mcp-tokens/`,
        headers: { Authorization: `Token ${token}`, "Content-Type": "application/json" },
        data: { label },
    }).then((response) => response).catch((error) => {
        console.log(error);
        return error;
    });
}

// Revoke an MCP token by its id.
export async function revokeMCPToken(token, id) {
    return axios({
        method: "delete",
        url: `${BASE_URL}/mcp-tokens/${id}/`,
        headers: { Authorization: `Token ${token}` },
    }).then((response) => response).catch((error) => {
        console.log(error);
        return error;
    });
}

// --- Admin (dev/superuser): all users' tokens ---

// List EVERY user's MCP tokens; each row includes its owner.
export async function listAllMCPTokens(token) {
    return axios({
        method: "get",
        url: `${BASE_URL}/admin-mcp-tokens/`,
        headers: { Authorization: `Token ${token}` },
    }).then((response) => response).catch((error) => {
        console.log(error);
        return error;
    });
}

// Revoke ANY user's MCP token by its id.
export async function revokeAnyMCPToken(token, id) {
    return axios({
        method: "delete",
        url: `${BASE_URL}/admin-mcp-tokens/${id}/`,
        headers: { Authorization: `Token ${token}` },
    }).then((response) => response).catch((error) => {
        console.log(error);
        return error;
    });
}
